import { AsyncPipe, DecimalPipe, KeyValuePipe, NgClass, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../../misc.module';
import { SanitizeHtmlPipe } from '../../../pipes/sanitize-html.pipe';
import { HomePageRoutingModule } from './home-routing.module';
import { HomePageComponent } from './home.page';

@NgModule({
  declarations: [HomePageComponent],
  imports: [
    AsyncPipe,
    DecimalPipe,
    HomePageRoutingModule,
    IonicModule,
    KeyValuePipe,
    MiscModule,
    NgClass,
    NgOptimizedImage,
    SanitizeHtmlPipe
  ]
})
export class HomePageModule {}
